export const timeRangeValues = {
  lastWeek: 'week',
  lastMonth: 'month',
  lastYear: 'year',
  custom: 'custom',
}

export const timeRangeOptions = [
  { value: timeRangeValues.lastWeek, label: 'Últimos 7 días' },
  { value: timeRangeValues.lastMonth, label: 'Últimos 30 días' },
  { value: timeRangeValues.lastYear, label: 'Último año' },
]
